import { render } from "./AdittionaServiceItem.vue?vue&type=template&id=4702f45e&scoped=true"
import script from "./AdittionaServiceItem.vue?vue&type=script&lang=js"
export * from "./AdittionaServiceItem.vue?vue&type=script&lang=js"

import "./AdittionaServiceItem.vue?vue&type=style&index=0&id=4702f45e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4702f45e"]])

export default __exports__